import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../routers/AuthProvider';
import { useForm } from '../../hooks/useForm';
import backArrowIcon from '../../assets/img/back-arrow.png';
import '../../assets/css/common.css';
import { Toast } from '../../components/ToastComponent';


const CreateLoyalty = () => {
    const backPath = '/loyalty/list';
    const { handleInputChange, formData, submitForm, setFormData, setError, error } = useForm();
     useEffect(()=>{
                      if(error){
                         Toast.fire({
                  title: error ,
                  icon: "error",
                });
                      }
                  },[error])

    const [errorMessage, setErrorMessage] = useState("");
    const [amount, setAmount] = useState();

    const [errorPointMessage, setErrorPointMessage] = useState("");
    const [point, setPoint] = useState();


    const navigate = useNavigate();
    const { user, setLoading } = useAuth();
    const onSubmit = (e) => {
        setLoading(true)
        e.preventDefault();
        const data = {
            ...formData,
            status: 'ACTIVE'
        }
        submitForm('POST', '/loyalty', data, () => {
        //     navigate(backPath)
        // });
         navigate(backPath)
        }, "Successfully Created");
    }

    return (
        <div className='sub-page-layout-1'>
            <Link className='back-to-page' to={backPath}>
                <img src={backArrowIcon} />
                Back
            </Link>
            <div className='container' style={{ height: 'auto' }}>
                <h1 className='sub-page-title'>Create Loyalty</h1>
                <div className='form-container'>
                    <form onSubmit={onSubmit} className='form flex flex-col justify-between w-full'>
                        <h2 className='sub-title mb-8'>Loyalty Information</h2>
                        <div className='grid grid-cols-2 gap-9'>
                            <div className='grow'>
                                <label className='x-label input-required'>Loyalty Name</label>
                                <input type='text'
                                    required
                                    name='loyalty_name'
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Loyalty Type</label>
                                <div className='dd-container'>
                                    <select
                                        type='text'
                                        required
                                        name='loyalty_type'
                                        defaultValue=''
                                        onChange={handleInputChange}
                                        className='x-input dropdown'
                                    >
                                        <option value='' disabled>Select</option>
                                        <option value='retail sale'>Loyalty for Retail Sale</option>
                                        <option value='wholesale'>Loyalty for Wholeale</option>
                                    </select>
                                </div>
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Amount</label>
                                <input type='text'
                                    required
                                    name='amount'
                                    value={amount}
                                    //onChange={handleInputChange}
                                    pattern="[0-9]{1,}"
                                    onChange={e => {
                                        const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                        setAmount(numericValue);

                                        const numeric = parseInt(numericValue, 10);

                                        if (!numericValue) {
                                            setErrorMessage("Please enter a number.");
                                        } else if (isNaN(numeric) || numeric < 1) {
                                            setErrorMessage("Number must be 1 or greater.");
                                        } else {
                                            setErrorMessage(""); // Clear message when valid
                                        }
                                        handleInputChange({ target: { name: 'amount', value: numericValue } });
                                    }}

                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    className='x-input' />
                                    {errorMessage && (
                                    <div className="text-red-500 text-sm mt-1">{errorMessage}</div>
                                )}
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Point</label>
                                <input type='text'
                                    required
                                    name='point'
                                    //onChange={handleInputChange}
                                    value={point}
                                    pattern="[0-9]{1,}"
                                    onChange={e => {
                                        const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                        setPoint(numericValue);

                                        const numeric = parseInt(numericValue, 10);

                                        if (!numericValue) {
                                            setErrorPointMessage("Please enter a number.");
                                        } else if (isNaN(numeric) || numeric < 1) {
                                            setErrorPointMessage("Number must be 1 or greater.");
                                        } else {
                                            setErrorPointMessage(""); // Clear message when valid
                                        }
                                        handleInputChange({ target: { name: 'point', value: numericValue } });
                                    }}

                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    className='x-input' />
                                     {errorPointMessage && (
                                    <div className="text-red-500 text-sm mt-1">{errorPointMessage}</div>
                                )}
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Start Date</label>
                                <input type='date'
                                    required
                                    name='start_date'
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>End Date</label>
                                <input type='date'
                                    required
                                    name='end_date'
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div>
                        </div>
                        <div className='mt-8 form-btn-group'>
                           
                            <div className='flex justify-end gap-5 mt-5'>
                                <Link to={backPath} className='white-btn'>Cancel</Link>
                                <button className='gold-btn'>Create</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CreateLoyalty;